import { useQuery } from '@tanstack/react-query';

import { businessPlanQueryKeys } from '../businessPlan-qk';
import { BusinessPlanApi } from '../businessPlan.api';

export const useGetPublicOnePagePlan = (id: string) => {
  return useQuery({
    queryKey: businessPlanQueryKeys.onePagePublicPlan(id),
    queryFn: () => BusinessPlanApi.getPublicOnePagePlan({ id }),
    select: (data) => ({ ...data, plan: { ...data.plan, metadata: JSON.parse(data.plan.metadata) } }),
  });
};
